export const PERMISSIONS_EXPIRES_AT_FORMAT = 'YYYY-MM-DD'

export const PERMISSIONS_EXPIRES_AT_UNLIMITED_LABEL = 'Бессрочно'

export const PERMISSIONS_EXPIRES_AT_LABEL = 'Действует до'

export type PermissionsExpiresAtQuickFilter = {
  label: string
  months?: number
}

export const DEFAULT_PERMISSIONS_EXPIRES_AT_QUICK_FILTERS: PermissionsExpiresAtQuickFilter[] =
  [
    { label: PERMISSIONS_EXPIRES_AT_UNLIMITED_LABEL },
    { label: 'Месяц', months: 1 },
    { label: 'Полгода', months: 6 },
    { label: 'Год', months: 12 }
  ]
